export { default as Body } from "./Body";
export { default as BodyDescription } from "./BodyDescription";

export { default as MiddleBody } from "./MiddleBody";
export { default as Brands } from "./Brands";
export { default as GetinTouch } from "./GetinTouch";



// WEBPACK FOOTER //
// ./src/pages/ContactUs/components/index.js